import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import focusSessionReducer from './slices/focusSessionSlice';
import analyticsReducer from './slices/analyticsSlice';
import gamesReducer from './slices/gamesSlice';
import projectsReducer from './slices/projectsSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    focusSession: focusSessionReducer,
    analytics: analyticsReducer,
    games: gamesReducer,
    projects: projectsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

